var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('img',{class:_vm.$style.badge,attrs:{"src":require("@assets/images/badge_danger.svg"),"alt":">"}}),_vm._v(" "),_c('span',{class:_vm.$style.content},[_vm._v("\n      "+_vm._s(_vm.number)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }